import { observable, action } from 'mobx'
import api from '../api'

class SearchStore {

  @observable searchValue = ''

  @observable loading = false
  @observable searched = false

  @observable searchResults = []
  @observable errorMessage = undefined

  @action setSearch(searchValue) {
    this.searchValue = searchValue
  }

  @action restartSearch() {
    this.searched = false
  }

  @action resetSearch() {
    this.searchValue = ''
  }

  @action setErrorMessage() {
    this.errorMessage = 'search_no_results_message'
  }

  @action resetErrorMessage() {
    this.errorMessage = undefined
  }

  @action loadSearchResults(searchTerm) {
    return (searchTerm) => {
      this.loading = true
      api.Brands.bySearch(searchTerm)
        .then(action(( searchResults ) => {
          this.searchResults = searchResults
          if(searchResults && searchResults.length > 0) {
            this.resetErrorMessage()
          } else {
            this.setErrorMessage()
          }
        }))
        .finally(action(() => {
          this.loading = false
          this.searched = true
        }))
    }
  }

}

export default new SearchStore()



// WEBPACK FOOTER //
// ./src/stores/searchStore.js